import { render, staticRenderFns } from "./staticFooter.vue?vue&type=template&id=6007454e&scoped=true"
import script from "./staticFooter.vue?vue&type=script&lang=js"
export * from "./staticFooter.vue?vue&type=script&lang=js"
import style0 from "./staticFooter.vue?vue&type=style&index=0&id=6007454e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6007454e",
  null
  
)

export default component.exports